import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { MatDialogModule } from '@angular/material/dialog';
import { UploadExcelEmpleadosComponent } from './components/upload-excel-empleados/upload-excel-empleados.component';
import { EmpleadosTooltipComponent } from './components/empleados-tooltip/empleados-tooltip.component';
import { EmpleadosPageComponent } from './components/mantenimiento/empleados-page/empleados-page.component';
import { EmpleadosBarraSuperiorComponent } from './components/mantenimiento/empleados-barra-superior/empleados-barra-superior.component';
import { EmpleadosModalComponent } from './components/mantenimiento/empleados-modal/empleados-modal.component';
import { MaestrosModule } from '../configuracion/maestros/maestros.module';
import { EmpleadosFiltrosComponent } from './components/mantenimiento/empleados-filtros/empleados-filtros.component';
import { SqpComponentsModule } from 'src/app/shared/components/sqp-components/sqp-components.module';
import { SqpUiModule } from '@squarepoint/sqp-ui';



@NgModule({
  declarations: [
    UploadExcelEmpleadosComponent,
    EmpleadosTooltipComponent,
    EmpleadosPageComponent,
    EmpleadosBarraSuperiorComponent,
    EmpleadosModalComponent,
    EmpleadosFiltrosComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatProgressBarModule,
    AgGridModule,
    MatDialogModule,
    MaestrosModule,
    SqpComponentsModule,
    SqpUiModule
  ],
  exports: [
    EmpleadosPageComponent,
    EmpleadosModalComponent
  ]
})
export class EmpleadosModule { }
